export default __webpack_public_path__ + "static/media/Icewyntale Teleport.aaddddfe.PNG";